import { render, staticRenderFns } from "./sec-transacciones.vue?vue&type=template&id=f7470c7a&scoped=true&"
import script from "./sec-transacciones.vue?vue&type=script&lang=js&"
export * from "./sec-transacciones.vue?vue&type=script&lang=js&"
import style0 from "./sec-transacciones.vue?vue&type=style&index=0&id=f7470c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7470c7a",
  null
  
)

export default component.exports